import RequestBuilder from 'Resources/RequestBuilder';
import updateLabels from '../labelHelper';

const removeLabel = (rb: RequestBuilder, entity: string, selected: number, extraParams?: object) => {
	return updateLabels(entity, { name: '', entity: '' }, rb.build(), selected);
};
export default removeLabel;
